import classNames from 'classnames';
import EmptyPlaceholder, { IEmptyPlaceholderProps } from 'components/atoms/empty/EmptyPlaceholder';
import Loading from 'components/atoms/loading/Loading';
import { HTMLAttributes, ReactNode } from 'react';
import './ListWrapper.scss';

export type TListWrapperView = 'grid' | 'list';

interface IListWrapperProps<Item> extends HTMLAttributes<HTMLDivElement> {
  items?: Item[];
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  empty?: IEmptyPlaceholderProps;
  item?: (item: Item, key: number) => ReactNode;
  view?: TListWrapperView;
}

const ListWrapper = <Item,>({
  items,
  item,
  isLoading,
  isFetchingNextPage,
  empty,
  view = 'list',
  ...props
}: IListWrapperProps<Item>) => {
  const hasItems = !!items?.length;
  const isInitialLoading = isLoading && !hasItems;

  const resolvedView: TListWrapperView = isInitialLoading
    ? 'list'
    : !hasItems && !isLoading
      ? 'list'
      : view;
  return (
    <div
      key={items?.length}
      {...props}
      className={classNames('list-wrapper', `list-wrapper--${resolvedView}`, props.className)}
    >
      {!items?.length && !isLoading && <EmptyPlaceholder {...empty} />}
      {item?.length && items?.map(item)}
      {(isFetchingNextPage || isLoading) && <Loading />}
    </div>
  );
};

export default ListWrapper;
